<template>
    <div class="col-md-12">
        <!-- Información del producto -->
         <div class="row">
            <div class="col-md-12">
                <h5 class="text-primary">{{ store.productoNombre }}</h5>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3">
                <div class="form-group">
                    <label class="control-label">Aseguradora</label>
                    <p class="text-primary">{{ store.aseguradoraNombre }}</p>
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label class="control-label">Producto</label>
                    <p class="text-primary">{{ store.productoNombre }}</p>
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label class="control-label">Suma asegurada</label>
                    <select class="form-control" required="required" :disabled="!sumasAseguradas.length" v-model="store.sumaAsegurada">
                        <option value="" disabled selected>Seleccione una opción</option>
                        <option v-for="suma in sumasAseguradas" :key="suma" :value="suma">
                            {{ formatCurrency(suma) }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label class="control-label">Frecuencia de pago</label>
                    <select class="form-control" required="required" v-model="store.periodoPago">
                        <option value="" disabled selected>Seleccione una opción</option>
                        <option value="24">Quincenal</option>
                        <option value="12">Mensual</option>
                        <option value="4">Trimestral</option>
                        <option value="2">Semestral</option>
                        <option value="1">Anual</option>
                    </select>
                </div>
            </div>
        </div>

        <DerechoPolizaAviso />

        <!-- Tabla de asegurados -->
        <div class="row mt-3">
            <table class="table table-bordered table-hover">
                <thead>
                    <tr class="table-secondary">
                        <th class="text-begin">Nombre</th>
                        <th class="text-center">Edad</th>
                        <th class="text-center">Género</th>
                        <th class="text-center">Parentesco</th>                        
                        <th class="text-end">Fecha alta</th>
                        <th class="text-end">Fecha baja</th>
                        <th class="text-end">Prima</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="asegurado in store.asegurados" :key="asegurado.id">
                        <td>{{ asegurado.nombre }} {{ asegurado.paterno }} {{ asegurado.materno }}</td>
                        <td class="text-center">{{ asegurado.edad }}</td>
                        <td class="text-center">{{ asegurado.genero }}</td>
                        <td class="text-center">{{ asegurado.parentesco }}</td>                        
                        <td class="text-end">{{ asegurado.fechaAlta || store.inicioVigencia }}</td>
                        <td class="text-end">{{ asegurado.fechaFin || store.finVigencia }}</td>
                        <td class="text-end">{{ formatCurrency(asegurado.prima) }}</td>
                    </tr>
                    <tr>
                        <td colspan="6">Prima neta</td>
                        <td class="text-end fw-bold">{{ formatCurrency(store.sumaPrimas) }}</td>
                    </tr>
                    <tr>
                        <td colspan="6">Derecho de póliza</td>
                        <td class="text-end">{{ derechoTexto }}</td>
                    </tr>
                    <tr>
                        <td colspan="6">IVA</td>
                        <td class="text-end">{{ formatCurrency(store.montoIva) }}</td>
                    </tr>
                    <tr class="table-secondary">
                        <td colspan="6" class="fw-bold">Prima total</td>
                        <td class="text-end fw-bold">{{ formatCurrency(store.primaTotal) }}</td>
                    </tr>
                    <tr>
                        <td colspan="6" class="text-primary fw-bold">Prima periódica</td>
                        <td class="text-end text-primary fw-bold">{{ formatCurrency(store.primaPeriodica) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="row mt-3">
            <div class="col-md-3">
                <div class="form-group">
                    <label class="control-label">Número de póliza</label>
                    <input class="form-control" type="text" placeholder="Ingrese el número de póliza" required="required" v-model="store.poliza">
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label class="control-label">Fecha de solicitud</label>
                    <input class="form-control" type="date" required="required" v-model="store.fechaSolicitud">
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label class="control-label">Inicio de vigencia</label>
                    <input class="form-control" type="date" required="required" v-model="store.inicioVigencia">
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label class="control-label">Fin de vigencia</label>
                    <input class="form-control" type="date" required="required" v-model="store.finVigencia">
                </div>
            </div>
        </div>

        <div class="row mt-3">
            <div class="col-md-6">
                <div class="form-group">
                    <label class="control-label">Notas de orden de trabajo</label>
                    <textarea v-model="store.notasOrdenDeTrabajo" class="form-control" rows="3" style="resize: none;"
                        placeholder="Escriba aquí las notas que se integrarán a la orden de trabajo" required="required"></textarea>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label class="control-label">Observaciones internas</label>
                    <textarea v-model="store.observacionesInternas" class="form-control" rows="3" style="resize: none;"
                        placeholder="Escriba aquí sus observaciones y comentarios internos" required="required"></textarea>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { useSeguroStore } from '@/stores/seguroStore';
import DerechoPolizaAviso from './DerechoPolizaAviso.vue';
import api from '@/axios';

export default {
    name: 'FormularioVida',
    components: { DerechoPolizaAviso },
    setup() {
        const store = useSeguroStore();
        return { store };
    },
    data() {
        return {
            loading: false,
            error: null,
        };
    },
    computed: {
        derechoTexto() {
            return this.store.derechoPolizaEstado === 'ok' ? this.formatCurrency(this.store.derechoPoliza) : '—';
        },
        // En la tabla de tarifas de Vida Familiar la columna `deducible` guarda la suma asegurada.
        sumasAseguradas() {
            if (!this.store.tarifas || !this.store.tarifas.length) return [];
            const set = new Set(this.store.tarifas.map(t => t.deducible));
            return Array.from(set).sort((a, b) => a - b);
        },
        totalPrima() {
            if (!this.store.asegurados || !this.store.asegurados.length) return 0;
            return this.store.asegurados.reduce((sum, a) => sum + (parseFloat(a.prima) || 0), 0);
        },
    },
    watch: {
        'store.aseguradoraId'(val) { if (val) this.store.updateAseguradoraNombre(); },
        'store.productoId'(newVal, oldVal) {
            if (newVal) this.store.updateProductoNombre();
            if (newVal && newVal !== oldVal) this.fetchTarifas();
        },
        'store.sumaAsegurada'(val) { if (val) this.calcularPrimas(); },
        'store.asegurados': {
            handler() { if (this.store.sumaAsegurada) this.calcularPrimas(); },
            deep: true,
        },
        totalPrima: {
            handler(val) {
                this.store.sumaPrimas = val;
                this.calcularPrimaTotal();
            },
            immediate: true,
        },
        'store.periodoPago'() { this.calcularPrimaTotal(); },
        'store.derechoPoliza'() { this.calcularPrimaTotal(); },
        'store.fechaSolicitud'() { this.store.cargarDerechoPoliza(); },
        'store.iva'() { this.calcularPrimaTotal(); },
    },
    mounted() {
        this.store.updateAseguradoraNombre();
        this.store.updateProductoNombre();
        if (this.store.productoId) this.fetchTarifas();
        this.store.cargarDerechoPoliza();
        this.limpiarSumaFueraDeLista();
    },
    methods: {
        // `sumaAsegurada` arranca en 100,000,000 (valor de GMM): si no es una suma de las tarifas de Vida, se limpia.
        limpiarSumaFueraDeLista() {
            if (this.sumasAseguradas.length && !this.sumasAseguradas.includes(Number(this.store.sumaAsegurada))) {
                this.store.sumaAsegurada = '';
            }
        },
        formatCurrency(value) {
            if (value == null || value === '') return '$0.00';
            return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value);
        },
        async fetchTarifas() {
            if (!this.store.productoId) return;
            try {
                this.loading = true;
                this.error = null;
                const response = await api.get(`productos/${this.store.productoId}/detalles`);
                const data = response.data || {};
                if (data.producto) this.store.productoDetalle = data.producto;
                if (data.tarifas) this.store.tarifas = data.tarifas;
                this.limpiarSumaFueraDeLista();
            } catch {
                this.error = 'No se pudieron cargar las tarifas.';
            } finally {
                this.loading = false;
            }
        },
        async calcularPrimas() {
            if (!this.store.productoId || !this.store.asegurados?.length || !this.store.sumaAsegurada) return;
            try {
                this.loading = true;
                for (const asegurado of this.store.asegurados) {
                    if (!asegurado.edad) continue;
                    // Tarifa por suma asegurada (columna `deducible`) y rango de edad
                    const tarifaLocal = this.store.tarifas.find(t => {
                        if (t.deducible != this.store.sumaAsegurada) return false;
                        const [minStr, maxStr] = (t.edadRango || '').split('-');
                        return asegurado.edad >= parseInt(minStr) && asegurado.edad <= parseInt(maxStr);
                    });
                    asegurado.prima = tarifaLocal ? (tarifaLocal.tarifa || 0) : 0;
                }
                this.store.sumaPrimas = this.totalPrima;
            } catch {
                this.error = 'No se pudieron calcular las primas.';
            } finally {
                this.loading = false;
            }
        },
        calcularPrimaTotal() {
            const sumaPrimas = parseFloat(this.store.sumaPrimas) || 0;
            // Sin el derecho de póliza del año no se calcula el total (no se usa un monto supuesto).
            if (this.store.derechoPoliza == null) {
                this.store.montoIva = 0;
                this.store.primaTotal = 0;
                this.store.primaPeriodica = 0;
                return;
            }
            const derechoPoliza = parseFloat(this.store.derechoPoliza) || 0;
            const tasaIva = parseFloat(this.store.iva) || 0.16;
            const subtotal = sumaPrimas + derechoPoliza;
            this.store.montoIva = subtotal * tasaIva;
            this.store.primaTotal = subtotal + this.store.montoIva;
            const periodoPago = parseFloat(this.store.periodoPago) || 1;
            this.store.primaPeriodica = this.store.primaTotal / periodoPago;
        },
    },
};
</script>
